export default function usePlaceholder(context) {
  const isAustralia = context.country === 'Australia';
  // N.B. some of these conditions are redundant, but I think it's easiest
  // to reason about one case at a time.
  if (isAustralia) {
    return 'Search all of Westfield';
  } else {
    // Desktop, New Zealand, National
    return 'Search all of Westfield';
  }
}